import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";
import VehicleExport from "./export-tables/vehicle-export.jsx";
import TableBody from "./table-body.jsx";

const VehicleDataset = ({ data }) => {
    const barChartsDatasets = data?.barChartsDatasets || [];

    useEffect(() => {
        barChartsDatasets.forEach((bar, index) => {
            const values = bar.data?.map(i => i.count) || [];
            const labels = bar.data?.map(i => i.data) || [];

            GraphicUtils.barChart(`traffic-flow-vehicle-${index}`, values, labels, false);
            if (values.some(v => v > 0)) ReportUtils.createExportableTable(null, null, `Total de veículos por tipo`, 'vehicle-export');
        });
    }, [barChartsDatasets]);

    return (
        <>
            {barChartsDatasets.map((bar, index) => {
                const title = bar.title;
                const total = bar.data?.reduce((acc, item) => acc + parseInt(item.count || 0), 0) || 0;


                return (
                    <React.Fragment key={index}>
                        <div >
                            <div className="mt-4 flex flex-row flex-nowrap items-center justify-center gap-6 w-full">
                                <div className="text-[16px] font-bold text-right max-w-[50%]">
                                    {title}
                                </div>
                                <fieldset className="border border-gray-300 rounded px-8 pb-2 text-center cursor-pointer shrink-0 min-w-[300px]" title={title}>
                                    <legend className="mx-auto px-2 text-[15px] whitespace-nowrap">
                                        Total de passagens
                                    </legend>
                                    <h2 className="text-[20px]! font-bold text-black m-0">{total}</h2>
                                </fieldset>
                            </div>
                            <div className="chart-divisor"></div>

                            <TableBody title={title} span={"Fluxo por tipo de veículo"} id={`traffic-flow-vehicle-${index}`} vehicle={true} showLegend={false}/>
                        </div>
                    </React.Fragment>
                );
            })}

            <VehicleExport datasets={barChartsDatasets}/>
        </>
    );
};

export default VehicleDataset;